module.exports = __webpack_public_path__ + "static/img/jinghui.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jinghui.png
// module id = wwEO
// module chunks = 1